var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-outline-secondary mr-2",on:{"click":_vm.deleteQuestion}},[_vm._v("Delete Question "+_vm._s(_vm.questionIndex + 1))])}
var staticRenderFns = []

export { render, staticRenderFns }